module.exports = __webpack_public_path__ + "static/media/bin1.01149ac1.svg";